module.exports = __webpack_public_path__ + "img/google-pay.d32fb17.svg";